import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import { useParams } from "react-router";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { FaClockRotateLeft, FaEye, FaEyeSlash, FaPaperPlane, FaPlus, FaSquarePlus, FaTrash } from "react-icons/fa6";
import { studyDatasetsServices } from "../../../../APIServices/studyDatasetsServices";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import OndemandTransferHistory from "./OndemandTransferHistory";
import UseToggle from "../../../../Hooks/UseToggle";
import SplitPane from "react-split-pane";

const OndemandTransfer = ({ tableRef, onMouseDown }) => {
  const { toggle, setToggle } = UseToggle();
  const [datasetsList, setDatasetsList] = useState([]);
  const [datasets, setDatasets] = useState([]);
  const [password, setPassword] = useState("");
  const [logoutTime, setLogoutTime] = useState("");
  const [loading, setLoading] = useState(false);
  let { studyId } = useParams();
  const [showPassword, setShowPassword] = useState(true);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const getStudyLevelForm = async (e) => {
    setLoading(true);
    let data = await studyLevelFormManagementServices.getStudyLevelForm(
      studyId,
      LoginCat,
      "active"
    );
    setDatasetsList(data?.data || []);
    setLoading(false);
  };

  const handleChangeCheckbox = (formId) => {
    setDatasets((prevSelected) => {
      if (prevSelected.includes(formId)) {
        return prevSelected.filter((id) => id !== formId);
      } else {
        return [...prevSelected, formId];
      }
    });
  };

  const handleSelectAll = () => {
    if (datasets?.length === datasetsList.length) {
      setDatasets([]);
    } else {
      const allFormIds = datasetsList.map((item) => item.formId);
      setDatasets(allFormIds);
    }
  };

  const handleAddEmailField = () => {
    setEmails((prev) => [...prev, ""]);
  };

  const [emails, setEmails] = useState([]);
  
  const handleRemoveEmail = (index) => {
    setEmails((prev) => {
      const updated = [...prev];
      updated.splice(index, 1);
      return updated.length === 0 ? [""] : updated;
    });
  };

  const handleEmailChange = (index, value) => {
    const updated = [...emails];
    updated[index] = value;
    setEmails(updated);
  };

  // const [newEmail, setNewEmail] = useState("");

  // const handleAddEmail = () => {
  //   const trimmed = newEmail.trim();
  //   const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
  //   if (isValid) {
  //     setEmails((prev) => [...prev, trimmed]);
  //     setNewEmail("");
  //   } else {
  //     handleResponse({
  //       statusCode: 400,
  //       customMessage: "Please enter a valid email.",
  //     })
  //   }
  // };

  // const handleRemoveEmail = (index) => {
  //   setEmails((prev) => prev.filter((_, i) => i !== index));
  // };

  // const handleKeyPress = (e) => {
  //   if (e.key === "Enter") handleAddEmail();
  // };

  const addNewDatasetTransfer = async () => {
    let userData = {}
    userData.timer = logoutTime
    userData.password = password
    userData.datasets = datasets
    userData.emails = emails
    userData.studyId = studyId
    userData.type = "onDemand"
    userData.mode = StudyMode
    let data = await studyDatasetsServices.addNewDatasetTransfer(userData)
    if (data?.statusCode === 200) {
      setDatasets([])
      setEmails([])
      setPassword("")
      setLogoutTime("")
    }
  }

  useEffect(() => {
    getStudyLevelForm();
  }, []);
  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <button className={`updateProfile hstack gap-1`} onClick={() => setToggle()}>
          <FaClockRotateLeft /> View History
        </button>
        <button
          onClick={addNewDatasetTransfer}
          disabled={!logoutTime || !password || datasets?.length === 0 || emails?.length === 0}
          className={`updateProfile hstack gap-1`}>
          <FaPaperPlane /> Quick Transfer
        </button>
      </div>
      <SplitPane
        split="vertical"
        style={{ height: "calc(100vh - 182px)" }}
        className=""
        minSize={"60%"}
      >
        {loading ? (
          <PageLoader/>
        ) : (
          <Table ref={tableRef} className="m-0 custom-table" hover striped>
            <thead className="position-sticky top-0 z-1">
              <tr>
                <th
                  onMouseDown={(e) => onMouseDown(e, 0)}
                  style={{ width: 45 }}
                  className="text-center"
                >
                  <Form.Check
                    checked={datasets?.length === datasetsList.length && datasetsList.length > 0}
                    onChange={handleSelectAll}
                  />
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 1)}>Datasets</th>
                <th onMouseDown={(e) => onMouseDown(e, 2)}>Datasets Code</th>
              </tr>
            </thead>
            <tbody>
              {datasetsList.map((data, index) => (
                <tr className="CP" key={index}>
                  <td className="text-center">
                    <Form.Check
                      checked={datasets?.includes(data.formId)}
                      onChange={() => handleChangeCheckbox(data.formId)}
                    />
                  </td>
                  <td>{data?.formName}</td>
                  <td>{data?.domainCode}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        <div className="p-2">
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Logout Time{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="number"
              className="fontSize12"
              placeholder="Enter Logout Time in Minute"
              onChange={(e) => setLogoutTime(e.target.value)}
              value={logoutTime}
            />
          </Form.Group>
          <div className="position-relative">
            <Form.Label className="mb-1 fw-bold">
              Password{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type={showPassword ? "password" : "text"}
              placeholder={`Enter Password`}
              onChange={(e) => setPassword(e.target.value)}
              value={password}
            />
            <div
              className="position-absolute CP"
              style={{ top: 27, right: 7, cursor: "pointer" }}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash title="Hide Password" /> : <FaEye title="Reveal Password" />}
            </div>
          </div>
          <Form.Group className="mb-3">
            <Form.Label className="mb-1 fw-bold">
              Emails{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>{" "}
              <FaSquarePlus className="ms-2 CP" title="Add more emails" onClick={handleAddEmailField} />
            </Form.Label>
            {(emails.length > 0 ? emails : [""]).map((email, index) => (
              <div key={index} className="d-flex align-items-center mb-2">
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => handleEmailChange(index, e.target.value)}
                  className="me-2"
                />
                {emails.length > 1 && (
                  <FaTrash
                    className="text-danger CP"
                    onClick={() => handleRemoveEmail(index)}
                    style={{fontSize: 12}}
                    title="Remove Email"
                  />
                )}
              </div>
            ))}
          </Form.Group>
        </div>
      </SplitPane>
      <OndemandTransferHistory
        Show={!toggle}
        Hide={setToggle}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        Title={"Ondemand Transfer History"}
      />
    </>
  );
};

export default OndemandTransfer;
